export const BASE_URL = 'https://api.ogunstate.gov.ng/api'
export const TOKEN = '281|33xDtQxAC36coyPYWV7szw4B8JTyk2LnYWhep19B'